import styled from 'styled-components'

export const PaymentPillContainer = styled.div<{
  type: 'partial' | 'paid' | 'unpaid'
}>`
  background: ${({ type }) => type === 'partial' && '#FFF4EC'};
  background: ${({ type }) => type === 'paid' && '#EDF9F0'};
  background: ${({ type }) => type === 'unpaid' && '#FEEFEF'};
  height: 100%;
  border-radius: 8px;
  display: flex;
  align-items: center;
`

export const PaymentTitle = styled.p<{
  type: 'partial' | 'paid' | 'unpaid'
}>`
  color: ${({ type }) => type === 'partial' && '#B95000'};
  color: ${({ type }) => type === 'paid' && '#287D3C'};
  color: ${({ type }) => type === 'unpaid' && '#DA1414'};
  margin: 0px;
  margin-left: 6px;
  margin-right: 45px;
  font-family: ${({ theme }) => theme.fonts.main};
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 20px;
`
